import { gql, useMutation } from '@apollo/client';

import { GET_SUBSIDIARY_COMPANIES_BY_PARENT } from './get-subsidiary-companies.hook';

export const DELETE_SUBSIDIARY_COMPANY_BY_ID = gql`
  mutation deleteSubsidiaryCompanyById($companyId: ObjectId!) {
    deleteSubsidiaryCompanyById(companyId: $companyId)
  }
`;

export const useDeleteSubsidiaryCompanyById = ({ onSuccess }: { onSuccess: () => void }) => {
  const [deleteSubsidiaryCompanyById] = useMutation(DELETE_SUBSIDIARY_COMPANY_BY_ID, {
    onCompleted: onSuccess,
    refetchQueries: [GET_SUBSIDIARY_COMPANIES_BY_PARENT],
  });

  return deleteSubsidiaryCompanyById;
};
